import Vue from 'vue';
import Moment from 'moment';
import { Component, Inject, Ref } from 'vue-property-decorator';
import { ClassScheduleProvider } from './class-schedule.provider';

@Component({})
export class ClassBuilderCalendarMixin extends Vue {
  @Inject()
  ScheduleProvider: ClassScheduleProvider;

  @Ref('scheduleCalendar') readonly scheduleCalendar: HTMLElement;

  intervalHeight = 48;
  zoomFactor = 2;
  isZoomActivated = false;

  get firstInterval(): number {
    const startHour = this.ScheduleProvider.scheduleStartHour;

    return Moment(startHour, 'HH:mm').hour();
  }

  get intervalCount(): number {
    const endHour = this.ScheduleProvider.scheduleEndHour;

    return Moment(endHour, 'HH:mm').hour() - this.firstInterval;
  }

  mounted() {
    this.setIntervalHeight();
    this.setListeners();
  }

  beforeDestroy() {
    this.unsetListeners();
  }

  setIntervalHeight() {
    if (!this.isZoomActivated) {
      setTimeout(() => {
        this.refreshIntervalHeight();
      }, 500);
    }
  }

  refreshIntervalHeight() {
    const calendarHeaderHeight = 50;
    const defaultIntervalHeight = 48
    let clientHeight = 500;
    if (this.scheduleCalendar.clientHeight > clientHeight) {
      clientHeight = this.scheduleCalendar.clientHeight;
    }
    let intervalHeight = (clientHeight - calendarHeaderHeight) / this.intervalCount;

    if (intervalHeight < defaultIntervalHeight) {
      intervalHeight = defaultIntervalHeight;
    }

    this.intervalHeight = Math.floor(intervalHeight) - 2;
  }

  setListeners() {
    window.addEventListener('resize', this.setIntervalHeight);
  }

  unsetListeners() {
    window.removeEventListener('resize', this.setIntervalHeight);
  }

  zoomIn() {
    this.isZoomActivated = true;
    this.ScheduleProvider.calendarZoomOutDisabled = false;
    this.intervalHeight = Math.floor(this.intervalHeight * this.zoomFactor);

    if (this.intervalHeight >= 220) {
      this.ScheduleProvider.calendarZoomInDisabled = true;
    }
  }

  zoomOut() {
    const result = Math.floor(this.intervalHeight / this.zoomFactor);
    const scheduleCalendarHeight = this.scheduleCalendar.clientHeight;
    this.ScheduleProvider.calendarZoomInDisabled = false;

    if (result > 0 && (result * this.intervalCount) >= scheduleCalendarHeight) {
      this.intervalHeight = result;
    } else {
      this.isZoomActivated = false;
      this.ScheduleProvider.calendarZoomOutDisabled = true;
      this.refreshIntervalHeight();
    }
  }
}